import './InteractiveMapLayout.css';
import React from 'react';
import { canUseDOM } from '../../../utils';
const InteractiveMapLayout = _ref => {
  let {
    leftBar,
    rightBar,
    loading,
    params,
    rtl,
    stylesVariables,
    allowSearch = false,
    withMapModalView = false
  } = _ref;
  React.useEffect(() => {
    const breadcrumb = canUseDOM ? document.querySelector('.breadcrumb-nav') : null;
    if (breadcrumb) {
      breadcrumb.classList.add('with-interactive-map');
      return () => {
        breadcrumb.classList.remove('with-interactive-map');
      };
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `container m114-im ${loading ? 'loader-shown' : ''} ${withMapModalView ? 'modal-view' : ''}`,
    style: stylesVariables
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: "loader"
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: `m114-im__left-bar ${allowSearch ? 'search-mode' : ''} `
  }, leftBar, " "), /*#__PURE__*/React.createElement("div", {
    className: "m114-im__right-bar"
  }, rightBar))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1g79zid";
const ltrStyles = "lxyxjgy";
const rtlStyles = "r17jeof0";
export default InteractiveMapLayout;